import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './pages/Home';
import LoginRedirect from './pages/LoginRedirect';
import MasterLayout from "./layouts/MasterLayout";
import UmatProfileBook from "./pages/UmatProfileBook";
import UmatData from "./pages/UmatData";
import UmatList from "./pages/UmatList";
import UmatListNav from "./pages/UmatListNav";
import DaftarUmat from "./pages/DaftarUmat";
import DocumentsPage from "./pages/DocumentsPage";
import DocDirectPage from "./pages/DocDirectPage";
import GanzhiCalendarPage from "./pages/GanZhiCalendar";
import AgendaCalendar from "./pages/AgendaCalendar";
import AgendaForm from "./pages/AgendaForm";
import LookupTestPage from "./pages/LookupTestPage";
import RolePermissionCheck from "./pages/RolePermissionCheck";
import ProfilePicUpdate from "./pages/ProfilePicUpdate";
import TestPostPut from "./pages/TestPostPut";
import Presensi from "./pages/Presensi";
import PresensiReport from "./pages/PresensiReport";
import QRScan from "./pages/qrscan";
import QiuDaoBook from "./pages/QiuDaoBook";
import BanDaoForm from "./pages/BanDaoForm";
import UmatDataUpdate from "./pages/UmatDataUpdate";
import AgendaBook from "./pages/AgendaBook";
import AgendaBookReport from "./pages/AgendaBookReport";
import { ProfileDetails, QrLiEn, QrPusatPage } from "./me/MyProfile";
import PINChange from "./pages/PINChange";
import PINCreate from "./pages/PINCreate";
import AdminUsersPage from "./pages/AdminUsersPage";
import { LinkToUmat } from "./me/LinkToUmat";
import { preloadPinyin } from './utils/pinyinUtil';
import PINProtectedRoute from "./components/PINProtectedRoute";
import PreRegList from "./pages/PreRegList";
import PreRegFormSetup from "./pages/PreRegFormSetup";
import PreRegFormEntry from "./pages/PreRegFormEntry";
import SongsPage from "./pages/SongsPage";
import SongSharing from "./pages/SongSharing";
import MemoryGamePage from "./games/memory";
import ParittaPuzzlePage from "./games/puzzle";
import ParittaWritingPage from "./games/writing";
import SoulCookiesNav from "./games/soulcookiesnav";

const App = () => {

  useEffect(() => {
    preloadPinyin();
  }, []);

  if (!process.env.REACT_APP_BACKEND_URL) {
    return <p>
        Please specify your backend url with the <a href="https://create-react-app.dev/docs/adding-custom-environment-variables/" target="_blank" rel="noopener noreferrer">environment variable</a>:<br />
        <b>REACT_APP_BACKEND_URL</b>.<br />
        <br />
        For example launch this app with:<br />
        <b>REACT_APP_BACKEND_URL=http://localhost:1337 yarn start</b>
      </p>;
  }

  return (
  <>
    <Router>
        <Switch>
          <Route exact path="/connect/:providerName/redirect" component={LoginRedirect} />
          {/* ===== route for Home ===== */}
          <Route exact path="/" render={() => (
              <MasterLayout>
                <Home />
              </MasterLayout>
            )}
          />
          {/* ===== route for ProfileDetails ===== */}
          <Route exact path="/me" render={() => (<ProfileDetails />)} />
          {/* ===== route for PINChange ===== */}
          <Route exact path="/pin/change" render={() => (<PINChange />)} />
          {/* ===== route for PINCreate ===== */}
          <Route exact path="/pin/create" render={() => (<PINCreate />)} />
          {/* ===== route for QR Li En ===== */}
          <Route exact path="/myqr" render={() => (<QrLiEn />)} />
          {/* ===== route for QR Pusat ===== */}
          <Route exact path="/myqrpusat" render={() => (<QrPusatPage />)} />

          {/* ===== route for GanZhiCalendar ===== */}
          <Route exact path="/GanZhiCalendar" render={() => (<GanzhiCalendarPage />)} />

          {/* ===== route for AgendaCalendar ===== */}
          <Route exact path="/AgendaCalendar" render={() => (<AgendaCalendar />)} />
          {/* ===== route for AgendaForm ===== */}
          <Route exact path="/AgendaForm" render={() => (<AgendaForm />)} />

          {/* ===== route for LinkToUmat ===== */}
          <Route exact path="/linktoprofile" render={() => (<LinkToUmat />)} />
          {/* ===== route for lookupTestPage ===== */}
          <Route exact path="/LookupTestPage" render={() => (<LookupTestPage />)} />
          {/* ===== route for DocumentsPage ===== */}
          <Route exact path="/files" render={() => (<DocumentsPage />)} />
          {/* ===== route for DocDirectPage ===== */}
          <Route exact path="/filesdirect" component={DocDirectPage} />
          {/* ===== route for PreRegFormEntry ===== */}
          <Route exact path="/f" component={PreRegFormEntry} />
          {/* ===== route for Song Sharing ===== */}
          <Route path="/ss/:code" component={SongSharing} />

          {/* ===== route for Games ===== */}
          <Route exact path="/g/nav" render={() => (<SoulCookiesNav />)} />
          <Route exact path="/g/memory" render={() => (<MemoryGamePage />)} />
          <Route exact path="/g/puzzle" render={() => (<ParittaPuzzlePage />)} />
          <Route exact path="/g/writing" render={() => (<ParittaWritingPage />)} />


          {/* ===== route for UmatProfileBook ===== */}
          <PINProtectedRoute exact path="/profile" component={UmatProfileBook} />
          <PINProtectedRoute exact path="/profile/:id" component={UmatProfileBook} />
          {/* ===== route for UmatData ===== */}
          <PINProtectedRoute exact path="/UmatData" component={<UmatData />} />
          {/* ===== route for UmatList ===== */}
          <PINProtectedRoute exact path="/UmatList" component={<UmatList />} />
          {/* ===== route for UmatListNav ===== */}
          <PINProtectedRoute exact path="/UmatListNav" component={<UmatListNav />} />
          {/* ===== route for DataUmat ===== */}
          <PINProtectedRoute exact path="/DaftarUmat" component={<DaftarUmat />} />
          {/* ===== route for RolePermissionCheck ===== */}
          <PINProtectedRoute exact path="/RolePermissionCheck" component={<RolePermissionCheck />} />
          {/* ===== route for ProfilePicUpdate ===== */}
          <PINProtectedRoute exact path="/ProfilePicUpdate" component={<ProfilePicUpdate />} />
          {/* ===== route for TestPostPut ===== */}
          <PINProtectedRoute exact path="/TestPostPut" component={<TestPostPut />} />
          {/* ===== route for Presensi ===== */}
          <PINProtectedRoute exact path="/PresensiReport" component={PresensiReport} />
          <PINProtectedRoute exact path="/Presensi" component={Presensi} />
          <PINProtectedRoute exact path="/Presensi/:id" component={Presensi} />
          {/* ===== route for AdminUsersPage ===== */}
          <PINProtectedRoute exact path="/AdminUsersPage" component={<AdminUsersPage />} />
          {/* ===== route for QiuDaoBook ===== */}
          <PINProtectedRoute exact path="/QiuDaoBook" component={<QiuDaoBook />} />
          {/* ===== route for BanDaoForm ===== */}
          <PINProtectedRoute exact path="/BanDaoForm" component={BanDaoForm} />
          <PINProtectedRoute exact path="/BanDaoForm/:id" component={BanDaoForm} />
          {/* ===== route for QRScan ===== */}
          <PINProtectedRoute exact path="/QRScan" component={<QRScan />} />
          {/* ===== route for UmatDataUpdate ===== */}
          <PINProtectedRoute exact path="/UmatDataUpdate" component={<UmatDataUpdate />} />
          {/* ===== route for AgendaBook ===== */}
          <PINProtectedRoute exact path="/AgendaBook" component={AgendaBook} />
          <PINProtectedRoute exact path="/AgendaBook/:id" component={AgendaBook} />
          {/* ===== route for AgendaBookReport ===== */}
          <PINProtectedRoute exact path="/abr/:id" component={AgendaBookReport} />
          {/* ===== route for PreReg List & Form ===== */}
          <PINProtectedRoute exact path="/PreRegList" component={PreRegList} />
          <PINProtectedRoute exact path="/PreRegList/:id" component={PreRegList} />
          <PINProtectedRoute exact path="/PreRegFormSetup" component={PreRegFormSetup} />
          <PINProtectedRoute exact path="/PreRegFormSetup/:id" component={PreRegFormSetup} />
          {/* ===== route for SongsPage ===== */}
          <PINProtectedRoute exact path="/songs" component={<SongsPage />} />

        </Switch>
    </Router>
    </>
  );
}

export default App;
